// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","wrapper":"ArtifactChangeDetails__wrapper--V7","smallPadding":"ArtifactChangeDetails__smallPadding--tE"};